// src/loadPlaces.ts
import { loadGoogleMaps } from "./loadGoogleMaps";

export async function loadPlaces() {
  await loadGoogleMaps();
  await google.maps.importLibrary("places");
}
